import React from 'react';

import { EEcommerceProvider } from '@domain/enums/common/integrations/EEcommerceProvider';

import { useStoreConfig } from '@helpers/hooks/useStoreConfig';

import IntegrateForm from './IntegrateForm';
import CartPandaConfig from './CartPandaConfig';

const CartPanda: React.FC = () => {
  const { storeIntegrations } = useStoreConfig();

  const { store_front } = storeIntegrations;

  const foundIntegration = store_front.find(
    integration => integration.name === EEcommerceProvider.CART_PANDA,
  );

  if (foundIntegration?.is_active) {
    return <CartPandaConfig />;
  }

  return <IntegrateForm />;
};

export default CartPanda;
